export const IS_FETCHING_PORTADAS = 'IS_FETCHING_PORTADAS'
export const FETCH_PORTADAS_SUCCESS = 'FETCH_PORTADAS_SUCCESS'

export const IS_FETCHING_CATEGORIES = 'IS_FETCHING_CATEGORIES'
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS'
export const FETCH_VIDEO_CATEGORIES_SUCCESS = 'FETCH_VIDEO_CATEGORIES_SUCCESS'
export const FETCH_CONTENT_CATEGORIES_SUCCESS =
  'FETCH_CONTENT_CATEGORIES_SUCCESS'
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS'
export const CATEGORIES_CLEAR = 'CATEGORIES_CLEAR'
export const FETCH_CATEGORIES_FAIL = 'FETCH_CATEGORIES_FAIL'

export const IS_FETCHING_CONTENIDOS = 'IS_FETCHING_CONTENIDOS'
export const IS_FILTERING_CONTENIDOS = 'IS_FILTERING_CONTENIDOS'
export const FETCH_ALL_CONTENIDOS_SUCCESS = 'FETCH_ALL_CONTENIDOS_SUCCESS'
export const FETCH_CONTENIDOS_SUCCESS = 'FETCH_CONTENIDOS_SUCCESS'
export const FETCH_CONTENIDO_SUCCESS = 'FETCH_CONTENIDO_SUCCESS'
export const FETCH_RELATED_CONTENIDO_SUCCESS = 'FETCH_RELATED_CONTENIDO_SUCCESS'
export const FETCH_FEATURED_CONTENIDO_SUCCESS =
  'FETCH_FEATURED_CONTENIDO_SUCCESS'
export const CONTENIDOS_CLEAR = 'CONTENIDOS_CLEAR'
export const FETCH_CONTENIDOS_FAIL = 'FETCH_CONTENIDOS_FAIL'
export const HAS_MORE_CONTENIDOS = 'HAS_MORE_CONTENIDOS'

export const IS_FETCHING_VIDEOS = 'IS_FETCHING_VIDEOS'
export const IS_FILTERING_VIDEOS = 'IS_FILTERING_VIDEOS'
export const FETCH_ALL_VIDEOS_SUCCESS = 'FETCH_ALL_VIDEOS_SUCCESS'
export const FETCH_VIDEOS_SUCCESS = 'FETCH_VIDEOS_SUCCESS'
export const FETCH_VIDEO_SUCCESS = 'FETCH_VIDEO_SUCCESS'
export const FETCH_RELATED_VIDEO_SUCCESS = 'FETCH_RELATED_VIDEO_SUCCESS'
export const FETCH_FEATURED_VIDEO_SUCCESS = 'FETCH_FEATURED_VIDEO_SUCCESS'
export const VIDEOS_CLEAR = 'VIDEOS_CLEAR'
export const FETCH_VIDEOS_FAIL = 'FETCH_VIDEOS_FAIL'
export const HAS_MORE_VIDEOS = 'HAS_MORE_VIDEOS'

export const SIDE_BAR_OPEN = 'SIDE_BAR_OPEN'
export const SIDE_BAR_CLOSE = 'SIDE_BAR_CLOSE'
export const SIDE_BAR_CHANGE_TYPE = 'SIDE_BAR_CHANGE_TYPE'

export const IS_FETCHING_LOCALES = 'IS_FETCHING_LOCALES'
export const FETCH_LOCALES_SUCCESS = 'FETCH_LOCALES_SUCCESS'

export const IS_FETCHING_BASIC_MEDIA = 'IS_FETCHING_BASIC_MEDIA'
export const FETCH_BASIC_MEDIA_SUCCESS = 'FETCH_BASIC_MEDIA_SUCCESS'
export const FETCH_BASIC_MEDIA_FAIL = 'FETCH_BASIC_MEDIA_FAIL'
